import { render, staticRenderFns } from "./DeleteMultipleTrades.vue?vue&type=template&id=60a61a7b&scoped=true"
import script from "./DeleteMultipleTrades.vue?vue&type=script&lang=js"
export * from "./DeleteMultipleTrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a61a7b",
  null
  
)

export default component.exports